import { render, staticRenderFns } from "./OrmUtilitiesSideMenu.vue?vue&type=template&id=57ed9abc&scoped=true"
import script from "./OrmUtilitiesSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed9abc",
  null
  
)

export default component.exports